module.exports = __webpack_public_path__ + "img/survey.78a29ba8.webp";